import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';
import './EcommerceShowcase.css';

const FEATURES = [
  'Add & edit products in seconds',
  'Live inventory & stock status',
  'Orders, bookings & projects in one app',
  'No monthly platform fees'
];

const EASE = [0.22, 0.61, 0.36, 1];

function EcommerceShowcase() {
  const reduce = useReducedMotion();
  const rise = (d) =>
    reduce
      ? {}
      : {
          initial: { opacity: 0, y: 24 },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: true, amount: 0.3 },
          transition: { duration: 0.6, delay: d, ease: EASE }
        };

  return (
    <section className="vstore" aria-label="Online store, all managed in one place">
      <div className="vstore-panel">
        <motion.div className="vstore-text" {...rise(0)}>
          <h2 className="vstore-title">
            Your whole store, <span className="vstore-gold">managed in one place</span>.
          </h2>
          <p className="vstore-desc">
            List products, track inventory, take orders, and manage bookings from one simple app
            Versa Launch builds and runs for you, right from your phone.
          </p>
          <ul className="vstore-list">
            {FEATURES.map((f) => (
              <li key={f}>
                <span className="vstore-check"><Check size={13} strokeWidth={3} /></span>
                {f}
              </li>
            ))}
          </ul>
          <Link to="/plans" className="vstore-cta">
            See plans
            <ArrowRight size={16} strokeWidth={2.4} />
          </Link>
        </motion.div>

        <motion.div
          className="vstore-media"
          aria-hidden="true"
          initial={reduce ? false : { opacity: 0, y: 36, scale: 0.96 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7, delay: 0.1, ease: EASE }}
        >
          <img src="/hero-app/store-dashboard.png" alt="" className="vstore-img" loading="lazy" />
        </motion.div>
      </div>
    </section>
  );
}

export default EcommerceShowcase;
